// this query param is used for cross-org link sharing
// its distinct from `orgId` in case `orgId` is ever a real query param
export const ORG_ID_PARAM = 'wsOrgId';
export const SESSION_STORAGE_ORG_ID_KEY = 'organizationId';
